import {
  Checkbox,
  ListItemAvatar,
  ListItemButton,
  ListItemText,
  Paper,
} from "@mui/material";
import React from "react";
import { GroupModel } from "../NewProcessModule";
import { PeopleAlt } from "@mui/icons-material";
import { useDragItem } from "hooks";
import AvatarRem from "components/AvatarRem";

interface GroupAssociationItemProps {
  selected: boolean;
  ele: GroupModel;
  ind: number;
  onLaneMouseDown: any;
  selectedLane: string;
}
const GroupAssociationItem: React.FC<GroupAssociationItemProps> = ({
  ele,
  ind,
  selected,
  onLaneMouseDown,
  selectedLane,
}) => {
  const { dragging, onDrag, onDragEnd, onDragStart, ref } = useDragItem();
  return (
    <Paper
      ref={ref as any}
      sx={{
        p: 0,
        my: 1,
        backgroundColor: dragging
          ? (_) => _.palette.background.paper
          : "transparent",
      }}
      elevation={dragging ? 5 : 0}
      draggable={true}
      onDragStart={(e) =>
        onDragStart(e, (event: any) => {
          const dragData = {
            name: ele?.name,
            idparticipant: ele.id,
            idparticipanttype: 1,
            assignmentmode: 0,
          };
          event.dataTransfer.setData("application/json", JSON.stringify(dragData));
        })
      }
      onDragEnd={onDragEnd}
      onDrag={onDrag}
    >
      <ListItemButton
        disableGutters
        id={`groups${ele.id}`}
        onClick={() => {
          if (Boolean(selectedLane)) {
            onLaneMouseDown(selectedLane, {
              name: ele?.name,
              idparticipant: ele.id,
              idparticipanttype: 1,
              assignmentmode: 0,
            });
          }
        }}
      >
        <Checkbox
          checked={selected}
        />
        <ListItemAvatar>
          <AvatarRem icon={ele.icon || ""}>
            <PeopleAlt />
          </AvatarRem>
        </ListItemAvatar>
        <ListItemText key={`groups${ind}`}>{ele?.name}</ListItemText>
      </ListItemButton>
    </Paper>
  );
};

export default GroupAssociationItem;
